import { AudioAsset } from "../../../asset/types/audio-asset";
import SimpleTrack from "../../../../common/types/release/simple-track";

export const getACRTrackScore = (asset?: AudioAsset): number => {
  if (!asset) {
    return 0;
  }

  const matches: Record<string, number> = {};

  asset.validation.figerprintResults.forEach((fingerprint) => {
    return fingerprint.response.metadata?.music?.forEach((result) => {
      if (!(result.external_ids.isrc in matches)) {
        matches[result.external_ids.isrc] = 0;
      }

      matches[result.external_ids.isrc] += 1;
    })
  });

  if (!Object.values(matches).length) {
    return 0;
  }

  const total = Object.values(matches).reduce((memo2, value) => {
    return memo2 + (value / asset.validation.figerprintResults.length);
  }, 0);

  return total / Object.values(matches).length
};

export const getACRScore = (assets: AudioAsset[], tracks: SimpleTrack[]): number => {
  return assets.reduce((memo, asset) => {
    const track = tracks.find((t) => t.id === asset.id);

    if (!asset.validation.figerprintResults.length || !track) {
      return memo;
    }

    const score = getACRTrackScore(asset);

    if (score > memo) {
      return score;
    }

    return memo;
  }, 0);
};
